export default class Modal {
  constructor() {
    var modal = document.querySelector('.modal');

    if(typeof(modal) != 'undefined' && modal != null) {
      var html = document.querySelector('html');
      var modalClose =  document.querySelectorAll('.modal__close');
      var modalCloseAlternative =  document.querySelectorAll('.modal__close--alternative');
      var modalOverlay =  document.querySelectorAll('.modal__overlay');
      var modals = document.querySelectorAll('[data-modal-open]');
      var modalsAlternative = document.querySelectorAll('[data-modal-open--alternative]');
      var modalsIds = document.querySelectorAll('[data-modal-id]');
      var modalWithActiveSteps = document.querySelector('.make-your-complaint[data-active-step]');
      var cookieModal = document.querySelector('[data-modal-id="cookie"]');

      modalOverlay.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();

          if(element.getAttribute('data-close-modal') != 'no') {
            closeModal(this.parentNode, html);
          }      
        });        
      });
      
      function closeAll() {
        closeAllModals();
      }

      modalClose.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();

          let el = e.target.getAttribute('href');
  
          el && el.length > 2 ? window.location.pathname = el : null;
        });

        element.addEventListener('click', closeAll);      
      });

      modalCloseAlternative.forEach(element => {
        element.removeEventListener('click', closeAll , false);
        element.addEventListener('click', function(e) {
          e.preventDefault();

          let el = e.target.getAttribute('href');

          el && el.length > 2 ? window.location.pathname = el : null;

          var modal = element.parentNode.parentNode;
    
          closeModalAlternative(modal);
        });        
      });

      modals.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          toggleModal(this.getAttribute('data-modal-open'));
          
          let dataActiveStep;

          if(element.getAttribute('data-active-step-open')) {
            dataActiveStep = element.getAttribute('data-active-step-open');
            
            modalWithActiveSteps.setAttribute('data-active-step', '2');
            inputData();
          } else if(modalWithActiveSteps.getAttribute('data-active-step') == '2') {
            modalWithActiveSteps.setAttribute('data-active-step', '1');
            cleanData();
          }
        });
      });

      modalsAlternative.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();
          toggleModalAlternative(this.getAttribute('data-modal-open--alternative'));
        });
      });

      let empresa = {
        nomeEmpresa: 'Itau',
        selectEmpresa: '8',
        emailEmpresa: 'contato@itau.com.br'
      };

      function inputData() {
        modalWithActiveSteps.querySelector('[name="nomeEmpresa"]').value = empresa.nomeEmpresa;
        modalWithActiveSteps.querySelector('[name="selectEmpresa"]').value = empresa.selectEmpresa;
        modalWithActiveSteps.querySelector('[name="emailEmpresa"]').value = empresa.emailEmpresa;
      }

      function cleanData() {
        modalWithActiveSteps.querySelector('[name="nomeEmpresa"]').value = '';
        modalWithActiveSteps.querySelector('[name="selectEmpresa"]').value = '1';
        modalWithActiveSteps.querySelector('[name="emailEmpresa"]').value = '';
      }

      function toggleModal(modal) {
        var modal = document.querySelector('[data-modal-id="'+modal+'"]');

        modal.classList.contains('modal--active') ? null : openModal(modal);
      };

      function toggleModalAlternative(modal) {
        var modal = document.querySelector('[data-modal-id="'+modal+'"]');

        modal.classList.contains('modal--active') ? null : openModalAlternative(modal);
      };
    
      function openModal(modal) {
        closeAllModals();
        
        var html = document.querySelector('html');
        modal.classList.add('modal--active');
        html.classList.contains('overflowed') ? null : html.classList.add('overflowed');
      };

      function openModalAlternative(modal) {     
        var html = document.querySelector('html');
        modal.classList.add('modal--active');
        html.classList.contains('overflowed') ? null : html.classList.add('overflowed');
      };
    
      function closeModal(modal) {
        modal.classList.remove('modal--active');
        html.classList.contains('overflowed') ? html.classList.remove('overflowed') : null;
      };

      function closeModalAlternative(modal) {
        modal.classList.remove('modal--active');
      };

      function closeAllModals() {
        modalsIds.forEach(element => {
          element.classList.remove('modal--active');
        });

        html.classList.contains('overflowed') ? html.classList.remove('overflowed') : null;
      }

      if(cookieModal != null && cookieModal != undefined) {
        var cookie_btn = cookieModal.querySelector('.modal__button');

        cookie_btn.addEventListener('click', function(e) {
            closeModal(cookieModal);
        });

        function openCookieModal() {
          toggleModal('cookie');
        }

        openCookieModal();

      }

    };
  };
};

const modal = new Modal();
